import {
  fontStyles,
  ligonierBaseStyles as baseStyles,
  layoutStyles,
  responsiveStyles,
} from "@ligonier/shared/styles";
import { storeFooterStyles } from "./styles/store-footer";
import { calloutFooterStyles } from "./styles/callout-footer";
import { breadcrumbsStyles } from "./styles/breadcrumbs";
import { emailFooterStyles } from "./styles/email-footer";
import { footerGroupsStyles } from "./styles/footer-groups";
import { languagesStyles } from "./styles/languages";
import { tertiaryStyles } from "./styles/tertiary";

// LitElement expects an array of CSSResult objects for multiple styles
export const styles = [
  fontStyles,
  baseStyles,
  layoutStyles,
  storeFooterStyles,
  calloutFooterStyles,
  breadcrumbsStyles,
  emailFooterStyles,
  footerGroupsStyles,
  languagesStyles,
  tertiaryStyles,
  responsiveStyles,
];
